module.exports = __webpack_public_path__ + "static/media/Icon_8.f2f1e242.svg";